$(document).ready(function() {
    if ($('.js-welcome-container').length) {
        // if (window.matchMedia("(min-width: 1280px)").matches) {
        //     var offsetWelcome = $('.js-welcome-container').offset().top - 100;
        //     $(window).scroll(function () {
        //         if ($(this).scrollTop() >= offsetWelcome) {
                    $('.js-color-line').removeClass('is-hidden');
                // }
        //     });
        // }
    }
});

